import React, { useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import styles from "./CashierReport.module.scss";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export default function CashierReport(props) {
  const token = useSelector((state) => state.green.admin.login.token);

  const [gridApi, setGridApi] = useState("");

  const columnDefs = [
    {
      headerName: "Phone Number",
      field: "phoneNumber",
    },
    {
      headerName: "Gift Value",
      field: "voucherValue",
    },
    {
      headerName: "Gift Code",
      field: "voucherCode",
    },
    {
      headerName: "Date",
      field: "creationDate",
    },
    {
      headerName: "Status",
      field: "status",
    },
    {
      headerName: "Branch Name",
      field: "branchName",
    },
  ];

  const defaultColDef = {
    editable: false,
    filter: true,
    floatingFilter: false,
    resizable: false,
    minWidth: 150,
  };

  const merchantNamee = useParams().merchant;

  
  const onGridReady = (params) => {
    setGridApi(params.api);
    axios
      .get("https://evouchers.shareecoin.com/ownerReport", {
        params: {
          merchantName: merchantNamee === "greenCafe" ? "Green Cafe" : "odonuts",
          queryType: "totalVouchers",
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        params.api.applyTransaction({ add: res.data.vouchersList });
      });
  };

  const handleExport = () => {
    gridApi.exportDataAsCsv();
  };

  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`${styles.bgModal}`}
        fullscreen={true}
      >
        <Modal.Header closeButton>
          <Container>
            <Row>
              <Col xs={12}>
                <h4>Can Bank Report Details: </h4>
              </Col>
            </Row>
          </Container>
        </Modal.Header>
        <Modal.Body className={`${styles.bgModalGrey}`}>
          <Container>
            <Row>
              <Col xs={12}>
                <div className={`${styles.bgWhite} p-3 mt-3`}>
                  <div className="ag-theme-alpine" style={{ height: "400px" }}>
                    <AgGridReact
                      columnDefs={columnDefs}
                      defaultColDef={defaultColDef}
                      onGridReady={onGridReady}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} md={{ span: 6, offset: 3 }}>
                <div className="d-grid mt-3">
                  <Button
                    variant="success"
                    size="sm"
                    className={`${styles.downloadReportBtn}`}
                    onClick={() => {
                      handleExport();
                    }}
                  >
                    DOWNLOAD REPORT
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
}
